import { Box, Container } from "@mui/material";

import PasswordRecoveryForm from "components/auth/PasswordRecoveryForm";

const PasswordRecovery = () => {
  return (
    <Box width={1}>
      <Container>
        <Box
          pt={{ xs: 3, lg: 5 }}
          pb={{ xs: 4, lg: 7 }}
          display="flex"
          justifyContent="center"
        >
          <PasswordRecoveryForm />
        </Box>
      </Container>
    </Box>
  );
};

export default PasswordRecovery;
